import {
    updateStateAfterWidgetOptionChange,
    isMdaeWidgetOptionChangeEvent,
} from "../../../../common_components/mdae-framework";
import { cloneDeepWith, isEmpty } from 'lodash';
import {
    actionTypes as asyncTypes,
    isAsyncOperation,
    isAsyncComplete,
  } from "async-ops";
import { GET_CASE_BILLING_HISTORY } from "../services/get-case-billing-history";
export const TOGGLE_BILL_HISTORY_POPUP = "TOGGLE_BILL_HISTORY_POPUP";
export const SET_BILL_HISTORY_CASE_DETAIL_DATA = "SET_BILL_HISTORY_CASE_DETAIL_DATA";
export const SET_VISIBLE_IMPORT_CHARGES ="SET_VISIBLE_IMPORT_CHARGES";


const initialState = {
   caseData : {},
   billingData: {},
   isVisibleToPopulateAtRiskField:false,
   selectedValue:0 ,
   billingHistoryList:[],
   varToUpdate:'',
   isVisibleFromImportCharges:false
}

const BillHistoryReducer = (state = initialState, action) => {
    let newState;
    switch (action.type) {
    case TOGGLE_BILL_HISTORY_POPUP:
    case SET_BILL_HISTORY_CASE_DETAIL_DATA :
    case SET_VISIBLE_IMPORT_CHARGES:
    newState = cloneDeepWith(state);
        if (isMdaeWidgetOptionChangeEvent(action.data)) {
            newState = updateStateAfterWidgetOptionChange(newState, action.data);
        } else {
            newState = { ...newState, ...action.data };
        }
        return newState;
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_CASE_BILLING_HISTORY)(action)) {
        return { ...state,  billingHistoryList: [] };
      }
      if (isAsyncComplete(GET_CASE_BILLING_HISTORY)(action)) {
        const response = action.response;
        let selectedCaseDetailId = 0;

        if (!isEmpty(state.varToUpdate)) {
          const key = state.varToUpdate === "totalRevenueLoss"
            ? "totalRevenueLoss"
            : state.varToUpdate;
          const dynamicValue = response[0]?.[key + 'CaseDetailId'];

          if (dynamicValue) {
            selectedCaseDetailId = dynamicValue;
          }
          else {
            selectedCaseDetailId = response[0]?.atRiskCaseDetailId || 0;
          }
        }

        return {
          ...state,
          selectedValue: selectedCaseDetailId,
          billingHistoryList: response,
        };
      }
      return state;
    default:
      return state;
    }
  }

  export default BillHistoryReducer;

